export default __webpack_public_path__ + "static/media/ID_MIKE_Krusk.a1dafe60.jpg";